import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AdUnitsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ad_units"}/>
}
